var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import styled from 'styled-components';
import { LoaderBars } from '../components/LoaderBars';
import { MessageManager } from '../components/MessageManager';
import { fetchVideoViews } from '../requests';
var GlobalStateContext = React.createContext(undefined);
var GlobalDispatchContext = React.createContext(undefined);
var initState = {
    isGlobalLoading: false,
    modalActive: null,
    currentDropDown: null,
    messages: [],
    modalState: {
        // temp state for dev
        header: 'Your support request has been submitted!',
        message: 'We appreciate that you have taken the time to reach out to us. Our team will be reviewing your request shortly.',
    },
    video: {
        source: null,
        name: null,
        title: '',
        subtitle: '',
        showOnNeverSeen: false,
        views: null,
    },
    isSearching: false,
    changePasswordUrl: ""
};
/**
 * true means show modal false means dont
 * @param state
 * @returns
 */
function checkIfVideoModal(state) {
    state.video.views;
    state.video.name;
    state.video.showOnNeverSeen;
    if (state.video.showOnNeverSeen && state.video.views) {
        var found = state.video.views.find(function (v) { return v.videoName === state.video.name; });
        if (!found)
            state.modalActive = '';
    }
}
function globalReducer(state, action) {
    switch (action.type) {
        case 'set global loading': {
            return __assign(__assign({}, state), { isGlobalLoading: action.payload });
        }
        case 'set video': {
            var newState = __assign(__assign({}, state), { video: __assign(__assign({}, action.payload), { views: state.video.views }) });
            console.log(action.payload);
            checkIfVideoModal(newState);
            return newState;
        }
        case 'set video views': {
            var newState = __assign(__assign({}, state), { video: __assign(__assign({}, state.video), { views: action.payload }) });
            checkIfVideoModal(newState);
            console.log(newState);
            return newState;
        }
        case 'add video view': {
            var added_1 = false;
            var newViews = (state.video.views || []).map(function (v) {
                if (v.videoName === action.payload) {
                    v.views++;
                    added_1 = true;
                    v.lastViewDate = new Date().toISOString();
                    v.videoName;
                }
                return v;
            });
            if (!added_1)
                newViews.push({
                    videoName: action.payload,
                    views: 1,
                    lastViewDate: new Date().toISOString(),
                });
            return __assign(__assign({}, state), { video: __assign(__assign({}, state.video), { views: newViews }) });
        }
        case 'set modal active': {
            console.log(action);
            return __assign(__assign({}, state), { modalActive: action.payload.modal, modalState: action.payload.state || {} });
        }
        case 'set current dropdown': {
            return __assign(__assign({}, state), { currentDropDown: action.payload.currentDropDown });
        }
        case 'display message': {
            return __assign(__assign({}, state), { messages: __spreadArray(__spreadArray([], state.messages), [action.payload]) });
        }
        case 'set is searching': {
            return __assign(__assign({}, state), { isSearching: action.payload });
        }
        case 'changepassword': {
            return __assign(__assign({}, state), { changePasswordUrl: action.payload });
        }
        default: {
            throw new Error("Unhandled action type");
        }
    }
}
function GlobalProvider(_a) {
    var children = _a.children;
    var _b = React.useReducer(globalReducer, initState), state = _b[0], dispatch = _b[1];
    return (_jsx(GlobalStateContext.Provider, __assign({ value: state }, { children: _jsx(GlobalDispatchContext.Provider, __assign({ value: dispatch }, { children: _jsx(InitGlobalProvider, { children: children }, void 0) }), void 0) }), void 0));
}
var StyledInitGlobalProviderLoader = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: fixed;\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  top: 0;\n  left: 0;\n  background: rgba(0, 0, 0, 0.01);\n  z-index: 1000;\n  .global-loader-full {\n    animation: fadeIn 1.2s;\n  }\n  @keyframes fadeIn {\n    0% {\n      opacity: 0;\n    }\n    25% {\n      opacity: 0;\n    }\n    50% {\n      opacity: 0.2;\n    }\n    100% {\n      opacity: 1;\n    }\n  }\n"], ["\n  position: fixed;\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  top: 0;\n  left: 0;\n  background: rgba(0, 0, 0, 0.01);\n  z-index: 1000;\n  .global-loader-full {\n    animation: fadeIn 1.2s;\n  }\n  @keyframes fadeIn {\n    0% {\n      opacity: 0;\n    }\n    25% {\n      opacity: 0;\n    }\n    50% {\n      opacity: 0.2;\n    }\n    100% {\n      opacity: 1;\n    }\n  }\n"])));
function InitGlobalProvider(_a) {
    var children = _a.children;
    var global = useGlobalState();
    var dispatch = useGlobalDispatch();
    function fetchAndSetVideoViews() {
        return __awaiter(this, void 0, void 0, function () {
            var views;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetchVideoViews()];
                    case 1:
                        views = _a.sent();
                        dispatch({ type: 'set video views', payload: views });
                        return [2 /*return*/];
                }
            });
        });
    }
    useEffect(function () {
        fetchAndSetVideoViews();
    }, []);
    return (_jsxs(React.Fragment, { children: [children, global.isGlobalLoading ? (_jsx(StyledInitGlobalProviderLoader, { children: _jsx(LoaderBars, { className: 'global-loader-full' }, void 0) }, void 0)) : null,
            _jsx(MessageManager, {}, void 0)] }, void 0));
}
function useGlobalState() {
    var context = React.useContext(GlobalStateContext);
    if (context === undefined) {
        throw new Error('useGlobalState must be used within a GlobalProvider');
    }
    return context;
}
function useGlobalDispatch() {
    var context = React.useContext(GlobalDispatchContext);
    if (context === undefined) {
        throw new Error('useGlobalDispatch must be used within a GlobalProvider');
    }
    return context;
}
export { GlobalProvider, useGlobalState, useGlobalDispatch };
var templateObject_1;
